import React, { useState, useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { MainLayout } from './components/MainLayout';
import { SignInButton } from '../src/components/SignInButton';
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { CircularProgress } from '@mui/material';


function App() {
  const { instance, accounts } = useMsal();
  const [isInitialized, setIsInitialized] = useState(false);
  const [accessToken, setAccessToken] = useState(sessionStorage.getItem("accessToken") || null);
  const [tokenExpired, setTokenExpiried] = useState(false)

  const isTokenExpired = (token) => {
    if (!token) return true;

    const [, payload] = token.split(".");
    const decodedPayload = JSON.parse(atob(payload));
    const currentTime = Math.floor(Date.now() / 1000);
    return decodedPayload.exp < currentTime;
  };
  const getAccessToken = async () => {

   setTokenExpiried(true)
    if (instance) {
      setIsInitialized(true);
    } else {
      console.error("MSAL instance is not initialized yet");
    }
    if(isTokenExpired(accessToken)){
      setAccessToken(null)
      sessionStorage.setItem("accessToken", "");
    }
    try {
      const response = await instance.acquireTokenSilent({
        scopes: ["api://myapp2/access_as_user", "offline_access"],
        account: accounts[0],
      });
      sessionStorage.setItem("accessToken", response.accessToken);
      setAccessToken(response.accessToken);
    } catch (error) {
      if (error instanceof InteractionRequiredAuthError) {
        try {
          const response = await instance.acquireTokenPopup({
            scopes: ["api://myapp2/access_as_user", "offline_access"],
          });
          sessionStorage.setItem("accessToken", response.accessToken);
          setAccessToken(response.accessToken);
        } catch (popupError) {
          console.error("Popup token acquisition failed:", popupError);
        }
      } else {
        console.error("Token acquisition error:", error);
      }
    }
    setTokenExpiried(false)

   
  };

  useEffect(() => {
    const initialize = async () => {
      if (accounts && accounts.length > 0) {
        if (!accessToken || isTokenExpired(accessToken)) {
          if(!tokenExpired){
           await getAccessToken();
          }
        }else if (isTokenExpired(accessToken)){
          if(!tokenExpired){
          await getAccessToken();
          }
        }
      }
      setIsInitialized(true);
    };
    initialize();
  }, [instance, accounts, accessToken]);

  return (
    <div>
      {isInitialized ? (
        accounts && accounts.length > 0 ? (
          <MainLayout accounts={accounts} accessToken={accessToken}  />
        ) : (
          <SignInButton /> 
        )
      ) : (
        <div style={{textAlign: "center", marginTop: "20%"}}>
          <CircularProgress />
        </div>

      )}
    </div>
  );
}

export default App;
